export default __webpack_public_path__ + "static/media/EM0630.34I-22023_-15009_0.4cfe5496.jpg";